import correct1 from "./evaluations/correct1.png";
import correct2 from "./evaluations/correct2.png";
import wrong1 from "./evaluations/wrong1.png";
import wrong2 from "./evaluations/wrong2.png";

const getRandomSuccessImage = () => {
  const images = [correct1, correct2];
  return images[Math.floor(Math.random() * images.length)]
}

const getRandomFailureImage = () => {
  const images = [wrong1, wrong2];
  return images[Math.floor(Math.random() * images.length)]
}

const evaluationImages = { correct1, correct2, wrong1, wrong2 };

export default evaluationImages;
export { getRandomSuccessImage, getRandomFailureImage }